import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { FeatureFlagAPI } from '../api/FeatureFlagApi'
import Button from '@mui/joy/Button'
import Box from '@mui/joy/Box'
import Alert from '@mui/joy/Alert'
import { CaptionFieldV2 } from './CaptionFieldV2'
import { NetworkSelectListV2 } from './NetworkSelectListV2'
import { TimeFieldV2 } from './ui/TimeFieldV2'
import { DateFieldV2 } from './ui/DateFieldV2'
import { NETWORKS } from '../consts'
import _ from 'lodash'
import { CampaignAPI } from '../api/CampaignAPI'

export const SchedulerFormFields = ({
    date,
    time,
    caption,
    publishTo,
    readOnly,
    onChange,
    fileType,
}) => {
    const { campaignId } = useParams()

    const handleDateChange = (dt) => {
        onChange({
            date: dt,
            time,
            caption,
            publishTo,
        })
    }

    const handleTimeChange = (dt) => {
        onChange({
            time: dt,
            date,
            caption,
            publishTo,
        })
    }

    const handlePublishToChange = (publishTo) => {
        onChange({
            publishTo: publishTo,
            date,
            time,
            caption,
        })
    }

    const handleCaptionChange = (cptn) => {
        onChange({
            caption: cptn,
            date,
            time,
            publishTo,
        })
    }

    const canOmitCaption =
        !_.isEmpty(publishTo) &&
        publishTo.length === 1 &&
        publishTo[0].canonicalName === 'instagram_story'

    const featuresQuery = useQuery({
        queryKey: ['feature-flags'],
        queryFn: FeatureFlagAPI.getFeatureFlags,
    })

    const campaignQuery = useQuery({
        queryKey: ['campaign', campaignId],
        queryFn: () => CampaignAPI.get(campaignId),
        enabled: !!campaignId,
    })

    function isVideo() {
        // if the route has a campaign id, get asset type from api call
        // else fileType prop will be passed into the component
        const videoFileFormats = [
            'mp4',
            'mov',
            'avi',
            'wmv',
            'mkv',
            'flv',
            'mpeg',
            '3gp',
        ]
        if (campaignId)
            return campaignQuery.data.data.type == 'video_submission'
        else
            return (
                fileType?.includes('video') ||
                videoFileFormats.includes(fileType)
            )
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <DateFieldV2
                label="Date"
                value={date}
                onChange={handleDateChange}
                disabled={readOnly}
            />
            <TimeFieldV2
                label="Time"
                value={time}
                onChange={handleTimeChange}
                disabled={readOnly}
            />
            {featuresQuery.isSuccess && (
                <NetworkSelectListV2
                    label="Publish To"
                    networks={NETWORKS}
                    selectedNetworks={publishTo}
                    onChange={handlePublishToChange}
                    featureFlags={featuresQuery.data.data.map(
                        (feature) => feature.name
                    )}
                    isVideo={isVideo()}
                />
            )}
            {!canOmitCaption && (
                <CaptionFieldV2
                    value={caption}
                    onChange={handleCaptionChange}
                    disabled={readOnly}
                />
            )}
        </Box>
    )
}
